export default __webpack_public_path__ + "static/media/impact-RTLG.555b8925.webp";